var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilledOrder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15.354 1.354-.708-.708L9 6.293 5.854 3.146l-.708.708L9 7.707z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M.978 3.5H0v-1h.978a2.5 2.5 0 0 1 2.29 1.497l2.237 5.105A1.5 1.5 0 0 0 6.879 10h4.885a1.5 1.5 0 0 0 1.342-.83l1.947-3.894.894.448L14 9.618A2.5 2.5 0 0 1 11.764 11H6.879a2.5 2.5 0 0 1-2.29-1.497L2.352 4.398A1.5 1.5 0 0 0 .978 3.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-1a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
  clipRule: "evenodd"
})));
export default SvgFilledOrder;